import React, {FC, useState } from 'react';
import './App.css';
import TodoTask from './Components/TodoTask';
import {interfaceTask} from './interface'

const App: FC = () =>  {

  function getcookie() {
    let decodedCookie = decodeURIComponent(document.cookie);
    let ce = decodedCookie.split(';');
    let c = "";
    let cetask = "";
    let cedesc = "";
    let cetask1 = "";
    let cedesc1 = "";
    let cetask2 = "";
    let cedesc2 = "";
    switch(ce.length) {
/*      case 0:
        return [];
        break;
*/      case 1:
        c = ce[0];
        if (c.length==0) {
          return [];
        } else {
          cetask = c.substring(0,c.indexOf("="));
          cedesc = c.substring(c.indexOf("=")+1,c.length);
          let pom = {taskName: cetask, description: cedesc} ;
          return [pom];
        }
        break;
      case 2:
        c = ce[0];
        cetask1 = c.substring(0,c.indexOf("="));
        cedesc1 = c.substring(c.indexOf("=")+1,c.length);
        c = ce[1];
        cetask2 = c.substring(0,c.indexOf("="));
        cedesc2 = c.substring(c.indexOf("=")+1,c.length);
        let pom12 = {taskName: cetask1, description: cedesc1} ;
        let pom22 = {taskName: cetask2, description: cedesc2} ;
        let pomar2 = [pom12,pom22];
        return pomar2;
        break;
      default:
        c = ce[0];
        cetask1 = c.substring(0,c.indexOf("="));
        cedesc1 = c.substring(c.indexOf("=")+1,c.length);
        c = ce[1];
        cetask2 = c.substring(0,c.indexOf("="));
        cedesc2 = c.substring(c.indexOf("=")+1,c.length);
        let pom1d = {taskName: cetask1, description: cedesc1} ;
        let pom2d = {taskName: cetask2, description: cedesc2} ;
        let pomard = [pom1d,pom2d];
        for(let i = 2; i <ce.length; i++) {
          c = ce[i];
          cetask = c.substring(0,c.indexOf("="));
          cedesc = c.substring(c.indexOf("=")+1,c.length);
          pom1d = {taskName: cetask, description: cedesc} ;
          pomard = pomard.concat(pom1d);
        }
        return pomard;
    }
  }

  let ces = getcookie();
  console.log(ces);
  const[task, setTask] = useState<string>("");
  const[description, setDescription] = useState<string>("");
  const[todoList, setTodoList] = useState<interfaceTask[]>(ces);

  function handleChange(event: any): void {
    if (event.target.name === "task") {
      setTask(event.target.value);
    } else {
      setDescription(event.target.value);
    }
  }

  const addTask = (): void => {
    const newTask = { taskName: task, description: description };
    setTodoList([...todoList, newTask]);
    setTask("");
    setDescription("");
    // ulozeni do cookies
    document.cookie = task + "=" + description;
  }

  const completeTask = (taskNameDelete: string):void => {
    setTodoList(todoList.filter((task) => {
      return task.taskName !== taskNameDelete
    }))
    document.cookie = taskNameDelete + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  return (
    <div className="App">
      <div className="header">
        <h1>Úkoly</h1>
        <div className="input">
          <form>
            <input
              name="task"
              type="text"
              placeholder="Nový úkol"
              value={task || ""}
              onChange={handleChange}
            />
            {!task ? null : (
              <>
                <textarea
                  name="description"
                  placeholder="Podrobnosti..."
                  value={description || ""}
                  onChange={handleChange}
                />
                <button onClick={addTask}>Přidat</button>
              </>
            )}
          </form>
        </div>
      </div>
      <div className="todoList">
        {todoList.map((task: interfaceTask, key: number) => {
          return <TodoTask key={key} task={task} completeTask={completeTask}/>;
        })}
      </div>
    </div>
  ); 

}

export default App;